import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageUploadTiles } from '../-components/PageUploadTiles'
import { useCoreUploadTiles } from '../-hooks/useCoreUploadTiles'
import { ORDER_SERVICE_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/order-service/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('uploads')
  const tiles = useCoreUploadTiles(ORDER_SERVICE_UPLOAD_TYPES)

  return (
    <PageUploadTiles
      tiles={tiles}
      header={t('uploadData.orderService.title')}
      description={t('uploadData.orderService.description')}
    />
  )
}
